import React from "react";
import { Modal } from "react-bootstrap";
import { XCircleFill } from "react-bootstrap-icons";
interface formModalProps {
  handleClose: () => void;
  show: boolean;
  modalTitle: string;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  modalSize: "sm" | "lg" | "xl";
  customClassName? : string
  showCross? : boolean
}
export default function FormModal(props: formModalProps) {
  const { show, handleClose, modalTitle, children, footer,modalSize, customClassName="", showCross=true } = props;
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size={modalSize}
        backdrop="static"
        centered={true}
        className= {customClassName}
      >
        <Modal.Header className="fw-bold fs-6 border-0 d-flex align-items-center modalTitleCustom p-4">
          {modalTitle}
          <button
            type="button"
            className="btn-close sph-close py-0 d-flex align-items-center"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <XCircleFill />
          </button>
        </Modal.Header>
        {children}
        <Modal.Footer className="border-0">{footer}</Modal.Footer>
      </Modal>
    </>
  );
}
